import { LIFECYCLE_STAGE_GOALS_TO_ADS } from '../constants/ads';
import { GOAL_TYPE } from '../constants/goals';
export const getAdCampaignIdsFromGoalTargets = goalTargets => {
  if (!goalTargets) return null;
  const assetIdArrays = goalTargets.filter(target => target.adCampaignAssetIds).map(target => Array.from(target.adCampaignAssetIds).map(assetId => assetId.split('-')[1]));
  const assetIdsArr = Array.from(assetIdArrays).flat().filter(adCampaignId => adCampaignId);
  return Array.from(new Set(assetIdsArr));
};
export const transformAdCampaignsData = adCampaign => {
  const extractValue = property => {
    if (!property || !adCampaign.properties[property]) return null;
    return adCampaign.properties[property].value;
  }; // check if hs_ad_network exists and if it does check if it equals google


  const adNetwork = extractValue('hs_ad_network') ? extractValue('hs_ad_network').toLowerCase().includes('google') ? 'adwords' : extractValue('hs_ad_network').toLowerCase() : null;
  const adCampaignAssetId = `${adNetwork}-${extractValue('hs_ad_campaign_id')}`.toLowerCase();
  return {
    adAccountId: extractValue('hs_ad_account_id'),
    adCampaignId: extractValue('hs_ad_campaign_id'),
    adCampaignAssetId,
    adNetwork,
    endDatetime: Number(extractValue('hs_end_datetime')),
    name: extractValue('hs_name'),
    objectId: adCampaign.objectId,
    status: extractValue('hs_status'),
    startDatetime: Number(extractValue('hs_start_datetime'))
  };
};
export const getAdCampaigns = data => {
  return data.results ? Object.values(data.results).reduce((adCampaignAcc, campaign) => {
    const parsedAdCampaign = transformAdCampaignsData(campaign);
    adCampaignAcc.push(parsedAdCampaign);
    return adCampaignAcc;
  }, []) : [];
};

const getGoalTypeCountField = goalTarget => {
  switch (goalTarget.goalType) {
    case GOAL_TYPE.NUMBER_OF_CONTACTS_IN_LIFECYCLE:
      return LIFECYCLE_STAGE_GOALS_TO_ADS[goalTarget.contactLifecycleStage];

    case GOAL_TYPE.NUMBER_OF_NETWORK_CONVERSIONS:
      return 'keyResults';

    case GOAL_TYPE.FIRST_FORM_SUBMISSION:
      return 'newContacts';

    default:
      return 'keyResults';
  }
};

export const parseAdSpend = (data, goalTarget) => {
  const extractReportEntity = (property, report) => {
    if (!property || !report || !report.entity || !report.entity[property]) {
      return null;
    }

    return report.entity[property];
  };

  const extractReportCost = (property, report) => {
    if (!property || !report || !report.report || !report.report.cost || report.report.cost[property] === null || report.report.cost[property] === undefined) {
      return null;
    }

    return report.report.cost[property];
  };

  const emptyMap = new Map();
  if (!data || !data.reports.length) return emptyMap;
  return data.reports.reduce((adSpendAcc, r) => {
    adSpendAcc.set(extractReportEntity('id', r), {
      campaignId: extractReportEntity('id', r),
      accountId: extractReportEntity('accountId', r),
      adSpend: extractReportCost('amount', r),
      currencyCode: extractReportCost('currencyCode', r),
      status: extractReportEntity('status', r),
      goalTypeCount: r.report && r.report[getGoalTypeCountField(goalTarget)] || 0
    });
    return adSpendAcc;
  }, emptyMap);
};